import { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import styled from "styled-components";
import { Button, SpinLoading } from "antd-mobile";
import useNavigation from "../../hooks/useNavigation";
import PageWrap from "../components/PageWrap";
import PageHeader, { headerHeight } from "../components/PageHeader";
import { useStores } from "../../models";
import { formatPrice, genPrivacyChatID } from "../../utils";
import {
  orderStatusText,
  paymentMethodTextMap,
} from "../../components/Wallet";
import { ToastError } from "../../components/Toast";

const ScrollArea = styled.div`
  height: calc(100% - ${headerHeight});
  overflow: auto;
  background: #f7f8ff;
  padding: 12px;
`;

const Card = styled.div`
  background: #fff;
  border-radius: 8px;
  padding: 14px;
  margin-bottom: 12px;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  font-size: 14px;
`;

const TakeOrderDetail = () => {
  const { params, navigate } = useNavigation();
  const { walletStore, userStore, chatStore, orderStore } = useStores();
  const [detail, setDetail] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await walletStore.getTakeOrders({
          id: params.id,
          current: 1,
          pageSize: 50,
        });
        const items = res?.data || res?.list || [];
        const found = Array.isArray(items)
          ? items.find(
              (x) =>
                String(x.id) === String(params.id) ||
                String(x.trans_no) === String(params.id) ||
                String(x.order_no) === String(params.id)
            ) || items[0]
          : items;
        setDetail(found || null);
      } finally {
        setLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);

  const meta = orderStatusText[detail?.status] || {
    text: detail?.status_text || "未知状态",
    color: "#999",
    description: "",
  };
  const isSeller = detail?.seller_id === userStore.currentUser?.id;

  return (
    <PageWrap>
      <PageHeader title="订单详情" />
      <ScrollArea>
        {loading ? (
          <SpinLoading />
        ) : !detail ? (
          <div style={{ textAlign: "center", padding: 40 }}>未找到订单</div>
        ) : (
          <>
            <Card>
              <div
                style={{
                  color: meta.color,
                  fontWeight: 700,
                  marginBottom: 10,
                  fontSize: 16,
                }}
              >
                {meta.text}
              </div>
              {meta.description ? (
                <div style={{ color: "#666", marginBottom: 12, fontSize: 13 }}>
                  {meta.description}
                </div>
              ) : null}
              <Row>
                <span>交易类型</span>
                <span>{isSeller ? "卖出" : "买入"}</span>
              </Row>
              <Row>
                <span>数量</span>
                <span>{detail.quantities} 喜鹊币</span>
              </Row>
              <Row>
                <span>单价</span>
                <span>{formatPrice(detail.amount || 0)}</span>
              </Row>
              <Row>
                <span>金额</span>
                <strong>
                  {formatPrice(
                    Number(detail.quantities || 0) * Number(detail.amount || 0)
                  )}{" "}
                  CNY
                </strong>
              </Row>
              <Row>
                <span>支付方式</span>
                <span>
                  {paymentMethodTextMap[detail.payment_method] ||
                    detail.payment_method ||
                    "-"}
                </span>
              </Row>
              <Row>
                <span>流水号</span>
                <span style={{ maxWidth: "60%", wordBreak: "break-all" }}>
                  {detail.trans_no || detail.order_no || params.id}
                </span>
              </Row>
              <Row>
                <span>对方</span>
                <span>
                  {isSeller
                    ? detail.username
                    : detail.seller_username || detail.name}
                </span>
              </Row>
            </Card>
            <Button
              color="primary"
              block
              onClick={() => {
                orderStore.onContactCs((user) => {
                  const { chat_id } = genPrivacyChatID(
                    userStore.currentUser.id,
                    user.id
                  );
                  const chat = chatStore.chats.get(chat_id);
                  if (chat) {
                    chatStore.setCurrent(chat);
                    navigate("Chat");
                  }
                }, ToastError);
              }}
            >
              联系客服
            </Button>
          </>
        )}
      </ScrollArea>
    </PageWrap>
  );
};

export default observer(TakeOrderDetail);
